import { Fragment } from 'react';
import Banner from '../components/Banner';
// import Highlights from '../components/Highlights';

export default function Home() {
	return (
		<Fragment>
			<Banner />
		</Fragment>
	)
}
